import { createLazyComponent } from '@muse-web/router'

import { AudioDetails } from './AudioDetails'

const loadLinkifiedAudioDetails = () =>
    import(/* webpackChunkName: 'audio-linkified-details' */ './LinkifiedAudioDetails')

export const AsyncLinkifiedAudioDetails = createLazyComponent(
    loadLinkifiedAudioDetails,
    'LinkifiedAudioDetails',
    { keepServerMarkup: true, fallback: AudioDetails },
)
